import { fontType } from 'shared/styles/functions'
import { theme } from 'shared/styles/theme'
import styled, { css } from 'styled-components'

export const GraphWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	${fontType(0)}
`

export const GraphContainer = styled.div<{ chartHeight: number }>`
	${({ chartHeight }) => css`
		height: ${chartHeight}px;
	`}
	width: 100%;
	min-width: 0;
`

export const AxisContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 12px;
	padding: 12px 0 0 20px;

	@media screen and (max-width: 600px) {
		padding: 12px 0 0 12px;
	}
`

export const Axis = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
`

export const AxisLabel = styled.span`
	color: ${theme.colors.blueishGrey};
	font-size: 11px;
`

export const AxisColorIndicator = styled.div<{ color: string }>`
	${({ color }) => css`
		width: 8px;
		height: 8px;
		border-radius: 2px;
		background-color: ${color};
	`}
`
